const getHexagramStyle = (hexagramName) => {
  switch (hexagramName) {
    case "Địa Thiên Thái":
    case "Địa Trạch Lâm":
    case "Địa Lôi Phục":
    case "Địa Phong Thăng":
    case "Địa Thủy Sư":
    case "Địa Sơn Khiêm":
    case "Thuần Càn":
    case "Thiên Hỏa Đồng Nhân":
    case "Thuần Đoài":
    case "Hỏa Địa Tấn":
    case "Hỏa Thiên Đại Hữu":
    case "Hỏa Phong Đỉnh":
    case "Lôi Địa Dự":
    case "Lôi Thiên Đại Tráng":
    case "Lôi Hỏa Phong":
    case "Lôi Phong Hằng":
    case "Lôi Thủy Giải":
    case "Phong Trạch Trung Phu":
    case "Phong Hỏa Gia Nhân":
    case "Phong Lôi Ích":
    case "Phong Sơn Tiệm":
    case "Thủy Địa Tỷ":
    case "Thủy Hỏa Ký Tế":
    case "Sơn Thiên Đại Súc":
      return { backgroundColor: "#33a854" };
    case "Địa Hỏa Minh Di":
    case "Thiên Địa Bĩ":
    case "Thiên Lôi Vô Vọng":
    case "Thiên Thủy Tụng":
    case "Thiên Sơn Độn":
    case "Trạch Thiên Quải":
    case "Trạch Hỏa Cách":
    case "Trạch Lôi Tùy":
    case "Trạch Phong Đại Quá":
    case "Trạch Thủy Khốn":
    case "Hỏa Trạch Khuê":
    case "Hỏa Lôi Phệ Hạp":
    case "Hỏa Thủy Vị Tế":
    case "Hỏa Sơn Lữ":
    case "Lôi Trạch Quy Muội":
    case "Thuần Chấn":
    case "Lôi Sơn Tiểu Quá":
    case "Phong Địa Quan":
    case "Phong Thiên Tiểu Súc":
    case "Thuần Tốn":
    case "Phong Thủy Hoán":
    case "Thủy Trạch Tiết":
    case "Thủy Lôi Truân":
    case "Thủy Phong Tỉnh":
    case "Thuần Khảm":
    case "Thủy Sơn Kiển":
    case "Sơn Địa Bác":
    case "Sơn Trạch Tổn":
    case "Sơn Phong Cổ":
    case "Sơn Thủy Mông":
    case "Thuần Cấn":
      return { backgroundColor: "#ea4236" };
    case "Thiên Trạch Lý":
    case "Thiên Phong Cấu":
    case "Trạch Địa Tụy":
    case "Trạch Sơn Hàm":
    case "Thuần Ly":
    case "Thủy Thiên Nhu":
    case "Sơn Hỏa Bí":
    case "Sơn Lôi Di":
    case "Thuần Khôn":
      return { backgroundColor: "#efb11e" };
    default:
      return {};
  }
};

export default getHexagramStyle;
